import NoticeMessage from "./components/notice-message";

export default class WoocommerceNotices {
    constructor(element) {

        this.root = element
        this.notices = this.root.querySelectorAll('.notice-message')

        if (this.notices) {
            this.notices.forEach((notice) => {
                new NoticeMessage(notice);
            })
        }
    }

}